<template>
  <div class="form-row no-margin">
    <label
      v-if="currentIndex == 0"
      class="lato-regular field-headings"
      for="validationCustom01"
    >{{inputLabel}}</label>
    <br />
    <datepicker
      class="w-100"
      :id="inputId"
      :value="defaultValue"
      :name="errorMessage"
      :required="isRequired"
      v-validate="'required'"
      :disabledDates="state.disabledDates"
      @selected="onChange($event)"
      :calendar-class="calClass"
      calendar-button="true"
      calendar-button-icon="calendar-icon"
    ></datepicker>
    <span
      class="helo-block alert alert-danger"
      v-show="errors.has(errorMessage)"
    >{{errors.first(errorMessage)}}</span>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  props: [
    "inputLabel",
    "inputId",
    "inputPlaceholder",
    "defaultValue",
    "isRequired",
    "errorMessage",
    "inputType",
    "validation",
    "calClass",
    "dateRange",
    "disabled",
    "currentIndex"
  ],
  data() {
    return {
      todayDate: "",
      // disabledDates: {
      //   to: ""
      // },
      state: {
        disabledDates: {
          from: "",
          to: ""
        }
      }
    };
  },
  created() {
    console.log(this.currentIndex);
    // let date = new Date();
    // date.setDate(date.getDate() - 1);
    // this.state.disabledDates.from = date;
    // this.state.disabledDates.to = new Date(1937, 0, 1);
    if (this.inputLabel == "Expiry Date") {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      let dateFrom = new Date();
      dateFrom.setFullYear(date.getFullYear() + 5);
      this.state.disabledDates.from = dateFrom;
      this.state.disabledDates.to = date;
      if (this.currentIndex != 0) {
        this.inputLabel = "";
      }
    } else if (this.inputLabel == "Issue Date") {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      this.state.disabledDates.from = date;
      this.state.disabledDates.to = new Date(2016, 0, 1);
      if (this.currentIndex != 0) {
        this.inputLabel = "";
      }
    } else {
    }
  },
  methods: {
    onChange(event) {
      let year = event.getFullYear();
      this.$emit("inputChange", event);
    }
  }
};
</script>

<style>
.label-heading {
  font-family: "Source Sans Pro", sans-serif;
}
.calendar-icon {
  background: url("../assets/calendar-icon.png");
  background-repeat: no-repeat;
  float: right;
  width: 25px;
  height: 100%;
  right: 0;
  margin-right: 10px;
  position: absolute;
  background-size: 18px;
  background-position: center;
}
.vdp-datepicker input {
  width: 100% !important;
  border: 1px solid #ced4da;
  color: #495057;
  border-radius: 0.25rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding-left: 15px;
}
.next {
  background: url("../assets/right.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 25px;
}
.next:hover {
  background-color: #eee !important;
  background-image: url("../assets/right.svg") !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 25px !important;
}
.prev {
  background: url("../assets/left.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 25px;
}
.prev:hover {
  background-color: #eee !important;
  background: url("../assets/left.svg") !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 25px !important;
}
.next::after,
.prev::after {
  border: none !important;
}
.cell.day {
  border: 0.5px solid #dfe3e8;
  border-left: none;
  border-top: none;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 14px;
  color: #637381;
}
.cell.day.selected {
  background: rgba(179, 188, 245, 0.15);
}
.disabled {
  background-color: rgb(255, 255, 255);
  color: rgb(219, 20, 20) !important;
  cursor: not-allowed !important;
}
.today {
  background-color: #e6f6fd;
}
.cell.day.weekend.sat {
  border-right: none;
}
.cell.day-header {
  border-bottom: 0.5px solid #dfe3e8;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 12px;
  color: #637381;
}
.day__month_btn {
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  /* line-height: 1.5; */
  letter-spacing: normal;
  color: #212b36;
}
</style>
